export default {
  servicesTypes: [],
  selectedService: null,
  error: false,
  errorMessage: ''
}
